const movieItem = [
    [
        {
            title: "دانلود فیلم",
            slug: "/movies",
        },
        {
            title: "۲۵۰ فیلم برتر تاریخ",
            slug: "/mov/best-250",
        },
        {
            title: "جدول باکس آفیس",
            slug: "/mov/box-office",
        },
        {
            title: "فیلم های بزودی",
            slug: "/mov/commingSoon",
        },
        {
            title: "فیلم های ۳ بعدی",
            slug: "/mov/3d",
        },
    ],
    [
        {
            title: "فیلم های دارای پخش آنلاین",
            slug: "/mov/online-play",
        },
        {
            title: "دانلود انیمیشن",
            slug: "/mov/animation",
        },
        {
            title: "فیلم های دوبله فارسی",
            slug: "/mov/dubled",
        },
        {
            title: "سینمای هند",
            slug: "/mov/india",
        },
    ],
];
const seriesItem = [
    [
        {
            title: "دانلود سریال‌",
            slug: "/series",
        },
        {
            title: "۲۵۰ سریال برتر تاریخ",
            slug: "/series/best-250",
        },
        {
            title: "پربازدیدترین سریال ها",
            slug: "/series/must-viewed",
        },
        {
            title: "سریال ها پایان یافته",
            slug: "/series/ended",
        },
        {
            title: "سریال های کره ای",
            slug: "/series/corean",
        },
        {
            title: "مینی سریال",
            slug: "/series/mini",
        },
    ],
    [
        {
            title: "سریال ها دارای پخش آنلاین",
            slug: "/series/online-play",
        },
        {
            title: "برترین سریال های قرن ۲۱",
            slug: "/series/best-century21",
        },
        {
            title: "سریال کنسل شده",
            slug: "/series/cancelled",
        },
        {
            title: "سریال های دوبله فارسی",
            slug: "/series/dubled",
        },
        {
            title: "سریال های انیمیشنی",
            slug: "/series/anime-series",
        },
        {
            title: "انیمه",
            slug: "/series/anime",
        },
    ],
];

const artistItem = [
    [
        {
            title: "برترین بازیگران مرد",
            slug: "/best-men-actors",
        },
        {
            title: "برترین کارگردانان",
            slug: "/best-directors",
        },
    ],
    [
        {
            title: "برترین بازیگران زن",
            slug: "/best-women-actors",
        },
        {
            title: "اخبار سینما و هنرمندان",
            slug: "/news",
        },
    ],
];

export { artistItem, seriesItem, movieItem };
